$(window).on("load", function (e) { 
    e.preventDefault();    
   $("footer.footer .footer__body .footer__content .footer__nav > ul > .menu__item.menu__item--has-dropdown > a").attr('href','javascript:void(0)')

    $("footer.footer .footer__body .footer__content .footer__nav > ul > .menu__item.menu__item--has-dropdown > a").click(function (e) {
     if($(this).parent("li").hasClass("sub-menu-open")){
       $(this).parent("li").removeClass("sub-menu-open");
       $(this).parent("li").find("ul.menu__dropdown").slideUp();
      }else{
        $(this).parent("li").addClass("sub-menu-open");
        $(this).parent("li").find("ul.menu__dropdown").slideDown();
      }
    })

  });


$(".collection .collection__inner .shopify-section .bc-sf-filter-option-block .bc-sf-filter-block-title").prepend('<span class="sub-toggle"><svg xmlns="http://www.w3.org/2000/svg" width="13.946" height="9.152" viewBox="0 0 13.946 9.152"><path d="M90.179,0,88,2.179l4.794,4.794L88,11.767l2.179,2.179,6.973-6.973Z" transform="translate(13.946 -88) rotate(90)" fill="#fff"/></svg></span>');

$(".bc-sf-filter-block-title").click(function(e) {
  var parentTitle = $(this).parent();
  var blockContent = parentTitle.find(".bc-sf-filter-block-content");
  //$(".bc-sf-filter-option-block").not(parentTitle).removeClass("sub-menu-open");
  parentTitle.toggleClass("sub-menu-open");
  blockContent.slideToggle();
});

 // $(".bc-sf-filter-selection-wrapper + .bc-sf-filter-option-block-list .sub-toggle").trigger("click");


/**** Mobile collections ***/

if ($(window).width() <= 767) {
    function getUrlVars2() {
        var vars = [], hash;
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('/');
        for (var i = 0; i < hashes.length; i++) {
            hash = hashes[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = true;
        }
        return vars;
    }
}

